/// <amd-module name="Test/Analytics/Common/Utils/TcmTelemetryConstants" />
export const area = "TestManagement";

// Telemetry Features
export const featureTestAX_ReportClick = "TestAX_ReportClick";
export const featureTestAX_PassRateCard = "TestAX_PassRateCard";
export const featureTestAX_FailedTestsCard = "TestAX_FailedTestsCard";
export const featureTestAX_FlakyTestsCard = "TestAX_FlakyTestsCard";
export const featureTestAX_AggregateTrendChart = "TestAX_AggregateTrendChart";
export const featureTestAX_ResultsGrid = "TestAX_ResultsGrid";
export const featureTestAX_ResultsGridLoadMore = "TestAX_ResultsGridLoadMore";
export const featureTestAX_ResultsGridElement = "TestAX_ResultsGridElement";
export const featureTestAX_TestTrendChart = "TestAX_TestTrendChart";
export const featureTestAX_TestHistoryGrid = "TestAX_TestHistoryGrid";
export const featureTestAX_TestHistoryGridLoadMore = "TestAX_TestHistoryGridLoadMore";
export const featureTestAX_ViewTest = "TestAX_ViewTest";
export const featureTestAX_Filter = "TestAX_Filter";
export const featureTestAX_TestDetailsView = "TestAX_TestDetailsView";
export const featureTestAX_FailuresReport = "TestAX_FailuresReport";
export const featureTestAX_TestInsightsReport = "TestAX_TestInsightsReport";
export const featureTestAX_NoTestResults = "TestAX_NoTestResults";

// Telemetry properties
export const Report = "Report";
export const TestFailures = "TestFailures";
export const Build = "Build";
export const Release = "Release";
export const WorkFlow = "WorkFlow";
export const Outcome = "Outcome";
export const IsCached = "IsCached";
export const Passed = "Passed";
export const Failed = "Failed";
export const NotExecuted = "NotExecuted";
export const FailedTests = "FailedTests";
export const ChartType = "ChartType";
export const GroupBy = "GroupBy";
export const Duration = "Duration";
export const LoadType = "LoadType";
export const Filters = "Filters";
export const FiltersCount = "FilterCount";
export const Clear = "Clear";
export const SortBy = "SortBy";
export const Rows = "Rows";
export const IsUserAction = "IsUserAction";
export const Type = "Type";
export const Test = "Test";
export const Group = "Group";
export const TestName = "TestName";
